<template>
  <div class="filter-container">
    <div class="mdl-textfield mdl-js-textfield mdl-selectfield">
      <input id="menu-input" value="Selecciona un filtro..."
        class="mdl-textfield__input" type="text" readonly tabIndex="-1">
      <i class="material-icons">arrow_drop_down</i>
      <ul for="menu-input" class="mdl-menu mdl-menu--bottom-left mdl-js-menu" @click="menuItemSelected">
        <li class="mdl-menu__item" data-filter="por-auditor">Por Auditor</li>
        <!-- <li class="mdl-menu__item" data-filter="por-fecha">Por Fecha</li> -->
        <li class="mdl-menu__item" data-filter="por-status">Por Status</li>
      </ul>
    </div>

    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
      <input class="mdl-textfield__input" type="text" id="text-filter" :disabled="inputDisabled"
        @keyup.enter="search">
      <label class="mdl-textfield__label" for="text-filter">Texto a buscar...</label>
    </div>

    <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
      @click="search" :disabled="inputDisabled">
      <i class="material-icons">search</i>
    </button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      inputDisabled: true
    }
  },
  methods: {
    menuItemSelected (event) {
      let menu = event.currentTarget,
          menuItem = event.target,
          menuInput = this.$el.querySelector('#menu-input'),
          textFilter = this.$el.querySelector('#text-filter')

      this.inputDisabled = false
      // ¿Porque Dios?.. ligero delay para que el focus jale..
      setTimeout(() => {
        menuInput.value = menuItem.textContent
        textFilter.dataset.filter = menuItem.dataset.filter
        menu.MaterialMenu.toggle()
        textFilter.focus()
      }, 10)
    },
    search (event) {
      const textFilter = event.currentTarget.type === 'text'
        ? event.currentTarget
        : this.$el.querySelector('#text-filter'),
            searchValue = textFilter.value,
            searchType  = textFilter.dataset.filter

      this.$emit('progress', true)
      this.$http.post('auditorias/newsfeed/search', {
          value: searchValue,
          type: searchType
        }).then(response => {
          this.$emit('update', response.data)
        })
    }
  },
  mounted () {
    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-textfield'))
    componentHandler.upgradeElement(this.$el.querySelector('.mdl-button'))
  }
}
</script>

<style lang="css" scoped>
  .filter-container {
    display: flex;
    flex-direction: row;
    margin: 1rem 0;
  }

  .filter-container:before {
    content: 'Filtros';
    position: absolute;
    font-weight: bold;
  }

  .filter-container .mdl-textfield {
    flex-grow: 10;
  }

  .filter-container .mdl-selectfield,
  .filter-container .mdl-selectfield input {
    flex-grow: 1;
    cursor: pointer;
  }

  .filter-container .mdl-textfield:first-child {
    margin-right: 1rem;
  }

  .filter-container .mdl-textfield > i.material-icons {
    position: absolute;
    top: 24px;
    right: 0;
    z-index: -1;
  }

  .filter-container .mdl-textfield > div,
  .filter-container .mdl-menu__item {
    width: inherit;
  }

  .filter-container button {
    margin-top: 1.5rem;
    margin-left: 0.75rem;
  }
</style>


// WEBPACK FOOTER //
// Filter.vue?7093ec0e